import React, { useState } from "react";

interface VideoPlayerProps {
  youtubeId: string;
  posterUrl?: string;
  title?: string;
}

export function VideoPlayer({
  youtubeId,
  posterUrl,
  title = "Guerilla Teaching Video",
}: VideoPlayerProps) {
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  // Generate thumbnail URL if not provided
  const thumbnailUrl = posterUrl || `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;

  const handlePlayClick = () => {
    setShowVideoPlayer(true);
    // Show the autoplay message after 2 seconds
    setTimeout(() => setShowMessage(true), 2000);
  };

  return (
    <div className="flex flex-col items-center w-full max-w-[500px]">
      <div className="relative w-full">
        {!showVideoPlayer ? (
          <div
            className="video-placeholder relative w-full cursor-pointer group"
            onClick={handlePlayClick}
          >
            <img
              src={thumbnailUrl}
              alt={title}
              className="w-full h-auto rounded-lg shadow-lg transition-transform duration-300 group-hover:scale-[1.02]"
            />
            <div className="play-button absolute inset-0 flex items-center justify-center">
              <div className="play-icon bg-[#8b5cf6] hover:bg-[#7c3aed] transition-all duration-300 w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center shadow-2xl group-hover:scale-110">
                <svg
                  className="w-8 h-8 sm:w-10 sm:h-10 ml-1 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          </div>
        ) : (
          <div className="video-player relative w-full" style={{ aspectRatio: "16 / 9" }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&controls=1&modestbranding=1&rel=0`}
              title={title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        )}
      </div>

      {/* Autoplay Warning Message */}
      {showMessage && (
        <div className="mt-6 w-full">
          <p
            style={{
              fontSize: "0.95rem",
              color: "#e74c3c",
              padding: "1rem",
              backgroundColor: "#fff3cd",
              borderLeft: "4px solid #e74c3c",
              borderRadius: "4px",
              lineHeight: "1.6",
            }}
          >
            <strong>Note:</strong> If the video doesn't play, your browser's privacy settings may be blocking embedded content.
            You can watch it directly on{" "}
            <a
              href={`https://www.youtube.com/watch?v=${youtubeId}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#8b5cf6", textDecoration: "underline" }}
            >
              YouTube
            </a>.
          </p>
        </div>
      )}
    </div>
  );
}
